<script setup lang="ts">
interface Props {
	color?: string;
}
const props = defineProps<Props>();
</script>

<template>
	<button class="app-button" :class="{ [color]: true }" v-on="$attrs">
		<slot></slot>
	</button>
</template>

<style lang="scss">
.app-button {
	cursor: pointer;

	width: 100%;

	padding: 10px 20px;

	border: none;
	border-radius: 100px;

	font-size: 14px;
	font-weight: 700;

	transition: 0.25s;

	&,
	&.primary {
		background-color: $primary-color;
		color: white;
	}
	&.border {
		border: 1px solid $primary-color;
		color: $primary-color;
		background-color: white;
	}
	&.gray,
	&:disabled {
		background: #ebedf5;
		color: #aaabb3;
	}
}
</style>
